import { Selection } from "prosemirror-state";
import { Slice } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
import {
  parseFragmentStringToNode,
  parseFragmentToString,
  parseSliceToFragment,
  trimEmailHTML,
} from "../../hook/useEmailEditorPasting";
import { Editor } from "@tiptap/core/dist/packages/core/src/Editor";

export const pastingHandler = (slice: Slice, editor: Editor) => {
  const { selection, doc } = editor.view.state;

  const isAllSelected =
    selection.$from.pos === Selection.atStart(doc).$from.pos &&
    selection.$to.pos === Selection.atEnd(doc).$from.pos;

  const fragment = parseSliceToFragment(slice, editor.schema);
  let html = parseFragmentToString(fragment);
  let hasTextFromEditor = !!editor.getText().trim();

  if (!hasTextFromEditor || isAllSelected) {
    editor.commands.clearContent();
    html = trimEmailHTML(html);
  }

  const parsedSlice = parseFragmentStringToNode(html, editor.schema);
  return parsedSlice;
};

export function nodePasteRuleTrim(editor: Editor) {
  return new Plugin({
    props: {
      transformPasted: (slice) => pastingHandler(slice, editor),
    },
  });
}
